import { useState } from 'react';
import { HiChevronDown } from 'react-icons/hi';
import { useLanguage } from '@/contexts/LanguageContext';
import './FaqAccordion.css';

type FaqAccordionProps = {
  titleKey: string;
  namespace: string;
  itemIds: string[];
  className?: string;
};

export default function FaqAccordion({
  titleKey,
  namespace,
  itemIds,
  className = '',
}: FaqAccordionProps) {
  const { t } = useLanguage();
  const [openId, setOpenId] = useState<string | null>(itemIds[0] ?? null);

  return (
    <section className={`faq-accordion ${className}`.trim()}>
      <h2 className="faq-accordion-title">{t(titleKey)}</h2>
      <div className="faq-accordion-list">
        {itemIds.map((id) => {
          const isOpen = openId === id;
          const panelId = `faq-panel-${id}`;
          const buttonId = `faq-button-${id}`;

          return (
            <div key={id} className={`faq-item ${isOpen ? 'is-open' : ''}`}>
              <button
                type="button"
                id={buttonId}
                className="faq-item-trigger"
                aria-expanded={isOpen}
                aria-controls={panelId}
                onClick={() => setOpenId(isOpen ? null : id)}
              >
                <span>{t(`${namespace}.items.${id}.question`)}</span>
                <HiChevronDown className="faq-item-icon" aria-hidden="true" />
              </button>
              <div
                id={panelId}
                role="region"
                aria-labelledby={buttonId}
                className="faq-item-panel"
                hidden={!isOpen}
              >
                <p>{t(`${namespace}.items.${id}.answer`)}</p>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
